import { __assign, __read } from "tslib";
import querystring from 'querystring';
import { round } from 'lodash-es';
var GIF = /.gif$/;
var imageBucket = document.createElement('div');
imageBucket.style.display = 'none';
document.body.appendChild(imageBucket);
export function loadImage(url) {
    return new Promise(function (resolve, reject) {
        var img = new window.Image();
        imageBucket.appendChild(img);
        // Note we set onload *first* so that it's fired even if the
        // image is loaded from cache
        img.onload = resolve;
        img.onerror = reject;
        img.src = url;
    });
}
export function isGIF(url) {
    return GIF.test(url);
}
export function preloadImages(_a) {
    var dispatch = _a.dispatch, images = _a.images, successActionCreator = _a.successActionCreator, failureActionCreator = _a.failureActionCreator, loadingStartActionCreator = _a.loadingStartActionCreator;
    return Promise.all(images.map(function (_a) {
        var id = _a.id, url = _a.url;
        if (loadingStartActionCreator)
            dispatch(loadingStartActionCreator(id));
        return loadImage(url)
            .then(function () { return dispatch(successActionCreator(id)); })
            .catch(function () { return failureActionCreator && dispatch(failureActionCreator(id)); });
    }));
}
// Turn a URL into a formatted fastly URL
var FASTLY_URL = 'freetls.fastly.net/serve';
export var getFormattedImageUrl = function (thumbnailImage, maxWidth, containerAspectRatio) {
    if (maxWidth === void 0) { maxWidth = 320; }
    if (!thumbnailImage.url) {
        return null;
    }
    // If not a fastly URL, fallback to provided URL
    if (thumbnailImage.url.indexOf(FASTLY_URL) < 0) {
        return thumbnailImage.url;
    }
    var isPortrait = thumbnailImage.height > thumbnailImage.width;
    var shouldCrop = isPortrait;
    var maxHeight = maxWidth / containerAspectRatio;
    var cropAspectRatio = maxHeight < thumbnailImage.height ? maxWidth + ":" + maxHeight : '1:1';
    var imageUrlParams = {
        width: maxWidth,
        crop: shouldCrop ? ',offset-x0,offset-y0' : '',
        aspectRatio: shouldCrop ? cropAspectRatio : '',
    };
    var _a = __read(thumbnailImage.url.split('?'), 2), url = _a[0], queryPart = _a[1];
    var parsedQueryParams = querystring.parse(queryPart);
    var queryParams = __assign(__assign({}, parsedQueryParams), { width: imageUrlParams.width, crop: "" + imageUrlParams.aspectRatio + imageUrlParams.crop, dpr: window.devicePixelRatio });
    var queryParamsString = decodeURIComponent(querystring.stringify(queryParams));
    return url + "?" + queryParamsString;
};
// Given a thumbnail image and container aspect ratio, calculate required padding.
export var getThumbnailPadding = function (thumbnailImage, containerAspectRatio) {
    if (!thumbnailImage.url) {
        return 0;
    }
    var imageAspectRatio = thumbnailImage.width / thumbnailImage.height;
    var imagePaddingPercent = round(1 - containerAspectRatio / imageAspectRatio, 2);
    return imageAspectRatio > containerAspectRatio
        ? Math.min(0.05, imagePaddingPercent) * 100 + "%"
        : null;
};
